export function expectEl<T extends HTMLElement = HTMLElement>(
    query: string,
    rootEl: Element | Document = document,
): T {
    const el = rootEl.querySelector<T>(query);

    if (!el) {
        throw new Error(`[expectEl] Can't find \`${query}\` element`);
    }

    return el;
}

export function expectEls<T extends HTMLElement = HTMLElement>(
    query: string,
    rootEl: Element | Document = document,
): T[] {
    const els = rootEl.querySelectorAll<T>(query);
    return Array.from(els);
}

export type Unsub = (() => void) | Unsubs;

export class Unsubs {
    private fns: Unsub[] = [];

    public add(fn: Unsub): this {
        this.fns.push(fn);
        return this;
    }

    public unsub(): this {
        this.fns.forEach((unsub) => {
            if (typeof unsub === "function") {
                unsub();
            } else {
                unsub.unsub();
            }
        });
        return this;
    }

    public clear(): this {
        this.fns = [];
        return this;
    }
}

export function random(min: number, max: number): number {
    return Math.floor(min + Math.random() * max);
}
